import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck, Zap, Clock } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout.promptwearr.shop/cart/44479124242567:1';
export function PricingSection() {
  return <section id="pricing" className="py-12 md:py-24 bg-neutral-950 relative" data-id="element-81">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-brand-900/20 via-neutral-950 to-neutral-950 pointer-events-none" data-id="element-82" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-83">
        {/* Urgency Bar */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto bg-neutral-900 border border-brand-500/30 rounded-xl p-6 mb-8 md:mb-16 text-center" data-id="element-84">
          <h3 className="text-xl font-bold text-white mb-4 flex items-center justify-center gap-2" data-id="element-85">
            <Clock className="text-brand-500" data-id="element-86" /> Promoción por tiempo limitado
          </h3>
          <div className="flex justify-between text-sm text-neutral-400 mb-2" data-id="element-87">
            <span data-id="element-88">Cupos disponibles agotándose</span>
            <span className="text-brand-500 font-bold" data-id="element-89">80% completos</span>
          </div>
          <div className="w-full bg-neutral-800 rounded-full h-2.5 mb-2 overflow-hidden" data-id="element-90">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '80%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="bg-brand-500 h-2.5 rounded-full" data-id="element-91" />
          </div>
          <p className="text-xs text-neutral-500 uppercase tracking-wider" data-id="element-92">
            Últimos accesos a precio actual
          </p>
        </motion.div>

        <div className="text-center mb-8 md:mb-12" data-id="element-93">
          <h2 className="font-bebas text-5xl md:text-6xl text-white uppercase tracking-wide mb-4" data-id="element-94">
            Accedé a <span className="text-brand-500" data-id="element-95">Prompt Wear</span>
          </h2>
          <p className="text-xl text-neutral-400" data-id="element-96">
            Acceso inmediato y de por vida
          </p>
        </div>

        {/* Single Pricing Card */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-lg mx-auto bg-neutral-900 border-2 border-brand-500 rounded-2xl p-6 md:p-10 text-center relative shadow-glow mb-10 md:mb-16" data-id="element-97">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-500 text-white text-xs font-bold px-4 py-1 rounded-full uppercase tracking-wider" data-id="element-98">
            OFERTA ESPECIAL
          </div>

          <h3 className="text-2xl font-bold text-white mb-2 mt-2" data-id="element-99">
            🏆 PROMPT WEAR — Acceso Completo
          </h3>
          <p className="text-brand-400 font-medium mb-5 md:mb-8" data-id="element-100">
            1.600+ Prompts + 6 Bonos + Sistema Completo de Producción
          </p>

          <div className="mb-5 md:mb-8" data-id="element-101">
            <p className="text-neutral-500 line-through text-xl" data-id="element-102">$59.990</p>
            <p className="text-7xl font-bebas text-brand-500" data-id="element-103">$19.990</p>
          </div>

          <div className="text-left bg-neutral-950/50 rounded-xl p-5 mb-5 md:mb-8" data-id="element-104">
            <p className="text-sm font-bold text-white mb-3" data-id="element-105">¿Qué incluye?</p>
            <ul className="space-y-2 text-sm text-neutral-300" data-id="element-106">
              <li className="flex gap-2" data-id="element-107">
                <span className="text-brand-500" data-id="element-108">✓</span> Pack I – Diseños de
                Alto Impacto Comercial (400 prompts)
              </li>
              <li className="flex gap-2" data-id="element-109">
                <span className="text-brand-500" data-id="element-110">✓</span> Pack II – Nichos
                Rentables (400 prompts)
              </li>
              <li className="flex gap-2" data-id="element-111">
                <span className="text-brand-500" data-id="element-112">✓</span> Pack III –
                Vectorización y Producción (400 prompts)
              </li>
              <li className="flex gap-2" data-id="element-113">
                <span className="text-brand-500" data-id="element-114">✓</span> Pack IV – Variaciones
                y Escalado (400 prompts)
              </li>
              <li className="flex gap-2" data-id="element-115">
                <span className="text-brand-500" data-id="element-116">✓</span> 6 Bonos exclusivos
                (valor $60.000 ARS)
              </li>
              <li className="flex gap-2" data-id="element-117">
                <span className="text-brand-500" data-id="element-118">✓</span> Acceso de por vida +
                actualizaciones
              </li>
            </ul>
          </div>

          <Button href={CHECKOUT_URL} pulse className="w-full text-xl py-4" data-id="element-119">
            SÍ, QUIERO PROMPT WEAR →
          </Button>
          <p className="text-xs text-neutral-400 mt-4" data-id="element-120">
            Pago único · Acceso inmediato · Garantía 7 días
          </p>
        </motion.div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-8 text-neutral-400" data-id="element-121">
          <div className="flex items-center gap-2" data-id="element-122">
            <ShieldCheck className="text-brand-500" data-id="element-123" />
            <span className="text-sm font-medium" data-id="element-124">Pago seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-125">
            <Zap className="text-brand-500" data-id="element-126" />
            <span className="text-sm font-medium" data-id="element-127">Acceso en minutos</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-128">
            <ShieldCheck className="text-brand-500" data-id="element-129" />
            <span className="text-sm font-medium" data-id="element-130">Garantía 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}